<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  value: {
    type: String,
    default: 'subject',
  },
  label: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['change']);

const { t: $t } = useI18n();

const formatOptions = [
  {
    value: 'subject',
    label: 'PROFILE_SETTINGS.FORM.EMAIL_PREVIEW_FORMAT.SUBJECT',
  },
  {
    value: 'subject_with_note',
    label: 'PROFILE_SETTINGS.FORM.EMAIL_PREVIEW_FORMAT.SUBJECT_WITH_NOTE',
  },
];

const handleChange = value => {
  emit('change', value);
};
</script>

<template>
  <div class="flex flex-col gap-3 w-full">
    <div>
      <label class="text-n-gray-12 font-medium leading-6 text-sm">
        {{ label }}
      </label>
      <p class="text-n-gray-11">
        {{ description }}
      </p>
    </div>

    <div class="space-y-3 ms-5">
      <div
        v-for="option in formatOptions"
        :key="option.value"
        class="flex items-start gap-3"
      >
        <div class="flex items-center mt-0.5">
          <input
            :id="`email-preview-${option.value}`"
            type="radio"
            name="email-preview-format"
            :value="option.value"
            :checked="value === option.value"
            class="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500 focus:ring-2 focus:ring-offset-2 disabled:opacity-50"
            @change="handleChange(option.value)"
          />
        </div>
        <div class="min-w-0 flex-1">
          <label
            :for="`email-preview-${option.value}`"
            class="text-sm font-medium text-n-gray-12 cursor-pointer"
          >
            {{ $t(option.label) }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
input[type='radio'] {
  --tw-ring-color: #3b82f6;
}

input[type='radio']:checked {
  background-color: #3b82f6;
  border-color: #3b82f6;
}

input[type='radio']:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  box-shadow:
    0 0 0 2px #ffffff,
    0 0 0 4px #3b82f6;
}
</style>
